import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { getSubjectsRankingQuery, GetSubjectsRankingQueryResult, GetSubjectsRankingQueryVariables } from '../graphql/queries/getSubjectsRankingQuery';
import { RankingStudent, RankingItem } from '../types';

interface SubjectsRankingHookInput {
  courseId: string;

  from?: string;
  to?: string;
}

interface SubjectsRankingHookResult {
  courseId?: string;
  courseName?: string;
  students?: RankingStudent[];
  subjects?: RankingItem[];

  loading: boolean;
  error?: string;
  onRefetchRanking: () => void;
}

export default function useSubjectsRanking(input: SubjectsRankingHookInput): SubjectsRankingHookResult {
  const { courseId, from = '', to = '' } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading, error, refetch } = useQuery<GetSubjectsRankingQueryResult, GetSubjectsRankingQueryVariables>(getSubjectsRankingQuery, {
    variables: {
      courseId,
      queryParams: { startDate: from, endDate: to },
    },
    onError: showErrorNotification,
  });

  return {
    ...data?.subjectsRankingPayload,
    loading,
    error: getErrorMessage({ error }),

    onRefetchRanking: refetch,
  };
}
